import React from "react";

type Props = {
  message: string
}

const NotFound : React.FC<Props> = ({ message }) => {
  return (
    <>
      <div style={{ textAlign: "center" }} className="m-xsmall-top-2">
        <div className="m-xsmall-top-1">{message}</div>
      </div>
    </>
  );
};

NotFound.defaultProps = {
  message: "Oops!...",
};

export default NotFound;
